import { makeStyles } from '@material-ui/core';
import codey from './herodevs-codey.svg';

const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 28,
  },
});

// Codey, the HeroDevs mark, for the collapsed sidebar.
const LogoIcon = () => {
  const classes = useStyles();

  return <img className={classes.img} src={codey} alt="" />;
};

export default LogoIcon;
